const iconSmall = 20;
const iconLarge = 24;
const ImageSizes = {
    xsmall: { imageHeight: 32, imageWidth: 32 },
    small: { imageHeight: 48, imageWidth: 48, iconHeight: iconSmall, iconWidth: iconSmall },
    medium: { imageHeight: 64, imageWidth: 64, iconHeight: iconSmall, iconWidth: iconSmall },
    large: { imageHeight: 100, imageWidth: 100, iconHeight: iconSmall, iconWidth: iconSmall },
    xlarge: { imageHeight: 120, imageWidth: 120, iconHeight: iconLarge, iconWidth: iconLarge },
};
export const getImageSizeStyle = (size = 'medium') => {
    return ImageSizes[size];
};
export const getContainerStyle = (iconPosition, size) => {
    const { iconWidth, iconHeight } = getImageSizeStyle(size);
    return {
        alignItems: 'center',
        display: 'flex',
        height: 'fit-content',
        justifyContent: 'center',
        position: 'relative',
        width: 'fit-content',
        '& svg': {
            height: iconHeight,
            position: 'absolute',
            width: iconWidth,
            ...(iconPosition === 'left' && { left: 0 }),
            ...(iconPosition === 'right' && { right: 0 }),
            ...(size === 'xsmall' && { display: 'none' }),
        },
    };
};
//# sourceMappingURL=SquareProductImage.styles.js.map